import {action, observable, runInAction} from 'mobx'
import {fetchWithCsrf} from "../../src/utils/csrf";

export interface InformationItem {
  id: number;
  status: number;
  publish_dt: string;
  title: string;
  body: string;
  is_unread: string;
}

export interface InformationResponse {
  result: {
    code: number;
    status: number;
    message: string;
    unread_count: number | null;
  };
  value: InformationItem[];
}

export class KixGbcInformationStore {
  @observable
  public loading: boolean = false;

  @observable.ref
  public list: InformationItem[] = [];

  @observable
  public unreadCount: number | null = null;

  @action
  async getList(start: number = 0, num: number = 100, id?: number) {
    this.loading = true;

    try {
      const params: any = { start, num };
      if (id) {
        params.id = id;
      }

      const response = await fetchWithCsrf('/api/kix_gbc/informations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      });

      const data: InformationResponse = await response.json();

      runInAction(() => {
        if (data.result.code === 1) {  // ApiResultCode::$success = 1
          this.list = data.value || [];
          this.unreadCount = data.result.unread_count;
        } else {
          console.error('Information API error:', data.result.message);
          this.list = [];
        }
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        console.error('Information API fetch error:', error);
        this.list = [];
        this.loading = false;
      });
    }
  }

  @action
  async markAsRead(id: number) {
    try {
      await fetchWithCsrf('/api/kix_gbc/informations/read', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
    } catch (error) {
      console.error('Mark as read error:', error);
    }
  }
}

export const kixGbcInformationStore = new KixGbcInformationStore();
